import { WarrantyRegistrationSchema } from "@redotech/redo-return-operations-common/warranty-registration";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getWarrantyRegistration = {
  name: "getWarrantyRegistration" as const,
  input: z.object({
    returnId: zExt.objectId().nullish(),
    registrationId: zExt.objectId().nullish(),
  }),
  output: WarrantyRegistrationSchema,
};
